var Application;

require('../../../core/frontend/vendor_modules/jquery-2.1.4.js');

require('../../../core/frontend/vendor_modules/cookie.js');

require('../../../core/frontend/vendor_modules/stub-underscore.js');

require('../../../core/frontend/vendor_modules/mailcheck-1.1.js');

Application = (function() {
  var NAMESPACES;

  NAMESPACES = ['Collections', 'Models', 'Views'];

  function Application(instance) {
    var registerNamespace, registerTopLevelNamespace;
    this.ExperimentVersions = {};
    registerTopLevelNamespace = (function(_this) {
      return function() {
        return _(NAMESPACES).each(function(ns) {
          return _this[ns] = {};
        });
      };
    })(this);
    registerNamespace = (function(_this) {
      return function(name) {
        return _(NAMESPACES).each(function(ns) {
          return _this[ns][name] = {};
        });
      };
    })(this);
    registerTopLevelNamespace();
    registerNamespace("Subscription");
    registerNamespace("Validate");
  }

  return Application;

})();

if (window.Groupon == null) {
  window.Groupon = {};
}

Groupon.SubscriptionApp = new Application();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvc3JhamVuZHJhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDA4ODU0MzQyNjEtNDYxOTAvcHJvZHVjdGlvbi0yMDE3LjA3LjIxXzA5LjExL3N1YnNjcmlwdGlvbl9mbG93L21vZHVsZXMvZ3JvdXBvbi9mcm9udGVuZC9ncm91cG9uLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3NyYWplbmRyYW4vbmFwaXN0cmFuby9idWlsZC8xNTAwODg1NDM0MjYxLTQ2MTkwL3Byb2R1Y3Rpb24tMjAxNy4wNy4yMV8wOS4xMS9zdWJzY3JpcHRpb25fZmxvdy9tb2R1bGVzL2dyb3Vwb24vZnJvbnRlbmQvZ3JvdXBvbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZUEsSUFBQTs7QUFBQSxPQUFBLENBQVEsdURBQVI7O0FBQ0EsT0FBQSxDQUFRLGlEQUFSOztBQUNBLE9BQUEsQ0FBUSwwREFBUjs7QUFDQSxPQUFBLENBQVEsd0RBQVI7O0FBR007QUFFSixNQUFBOztFQUFBLFVBQUEsR0FBYSxDQUNYLGFBRFcsRUFFWCxRQUZXLEVBR1gsT0FIVzs7RUFNQSxxQkFBQyxRQUFEO0FBQ1gsUUFBQTtJQUFBLElBQUMsQ0FBQSxrQkFBRCxHQUFzQjtJQUV0Qix5QkFBQSxHQUE0QixDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUE7ZUFDMUIsQ0FBQSxDQUFFLFVBQUYsQ0FBYSxDQUFDLElBQWQsQ0FBbUIsU0FBQyxFQUFEO2lCQUNqQixLQUFLLENBQUEsRUFBQSxDQUFMLEdBQVc7UUFETSxDQUFuQjtNQUQwQjtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUE7SUFJNUIsaUJBQUEsR0FBb0IsQ0FBQSxTQUFBLEtBQUE7YUFBQSxTQUFDLElBQUQ7ZUFDbEIsQ0FBQSxDQUFFLFVBQUYsQ0FBYSxDQUFDLElBQWQsQ0FBbUIsU0FBQyxFQUFEO2lCQUNqQixLQUFLLENBQUEsRUFBQSxDQUFJLENBQUEsSUFBQSxDQUFULEdBQWlCO1FBREEsQ0FBbkI7TUFEa0I7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBO0lBSXBCLHlCQUFBLENBQUE7SUFDQSxpQkFBQSxDQUFrQixjQUFsQjtJQUNBLGlCQUFBLENBQWtCLFVBQWxCO0VBYlc7Ozs7Ozs7RUFnQmYsTUFBTSxDQUFDLFVBQVc7OztBQUVsQixPQUFPLENBQUMsZUFBUixHQUE4QixJQUFBLFdBQUEsQ0FBQSJ9
